import { heroStats } from "@/mocks/homeContent";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20dark%20warm%20amber%20and%20crimson%20gradient%20background%20with%20soft%20glowing%20light%20streaks%20and%20delicate%20film%20grain%20texture%2C%20elegant%20minimal%20composition%20with%20large%20empty%20space%20for%20text%20overlay%2C%20moody%20dramatic%20atmosphere%2C%20high%20contrast%2C%20no%20people%2C%20no%20text&width=1920&height=1080&seq=hantv-hero-01&orientation=landscape"
        alt=""
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>

      <div className="relative mx-auto grid w-full max-w-[1280px] grid-cols-1 items-center gap-10 px-4 py-16 md:px-6 md:py-24 lg:grid-cols-[1.15fr_0.85fr]">
        <div className="animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-3 py-1 font-label text-xs text-white backdrop-blur">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-fire-line text-xs text-primary-300"></i>
            </span>
            防走丢导航 · 持续同步
          </span>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-white md:text-5xl">
            韩剧TV 最新地址与访问指南
          </h1>

          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base">
            本页集中整理韩剧TV的最新地址动态、官网地址 2025 的说明、打不开的解决办法、新域名是多少以及永久入口与换网址后去哪里看。地址一旦发生变化，你可以从这里重新找到当前入口，避免地址走丢。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#updates"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-refresh-line"></i>
              </span>
              查看最新地址动态
            </a>
            <a
              href="#solutions"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/40 bg-white/10 px-5 py-3 font-label text-sm font-medium text-white backdrop-blur transition-colors hover:bg-white/20"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-tools-line"></i>
              </span>
              打不开怎么办
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 lg:grid-cols-1">
          {heroStats.map((stat) => (
            <div
              key={stat.label}
              className="flex items-center gap-3 rounded-lg border border-white/15 bg-white/10 p-4 backdrop-blur"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className={`${stat.icon} text-xl`}></i>
              </span>
              <div className="min-w-0">
                <p className="font-label text-xs text-white/70">{stat.label}</p>
                <p className="font-heading text-lg font-bold text-white">{stat.value}</p>
                <p className="truncate text-xs text-white/60">{stat.note}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}